import { UrlApi } from "../../../services/apirest";
import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import DialogContentText from "@mui/material/DialogContentText";
import InputLabel from "@mui/material/InputLabel";

import { MRT_Localization_ES } from "material-react-table/locales/es"; //idioma
import {
  // Componentes para los estilos
  Container,
  Typography,
  Snackbar,
  SnackbarContent,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
  Grid,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Delete, Edit } from "@mui/icons-material";
import PersonOffTwoToneIcon from "@mui/icons-material/PersonOffTwoTone";
import AppRegistrationTwoToneIcon from "@mui/icons-material/AppRegistrationTwoTone";
import PersonAddTwoToneIcon from "@mui/icons-material/PersonAddTwoTone";
import { grey } from "@mui/material/colors";
import WarningIcon from "@mui/icons-material/Warning";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import moment from "moment";
import MuiAlert from "@mui/material/Alert";
import Alerta from "../../Alerta";
import Notify from "../../Notify";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Editarvianda(props) {
  const [datospedido, setDatospedido] = useState(props.data);
  //console.log("datospedido", datospedido);
  const [pedidoParams, setPedidoParams] = useState(null);
  const [menusDiarios, setMenusDiarios] = useState([]);
  const [menusRotativos, setMenusRotativos] = useState([]);

  //separe en estados la seleccion porque chocaban con el id_menu
  const [menusDiariosSeleccionados, setMenusDiariosSeleccionados] = useState(
    []
  );
  const [menusRotativosSeleccionados, setMenusRotativosSeleccionados] =
    useState([]);
  //  console.log("menusDiariosSeleccionados", menusDiariosSeleccionados);
  // console.log("menusRotativosSeleccionados", menusRotativosSeleccionados);

  //estados para manejo de errores
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [colormensaje, setColorMensaje] = useState(""); //define el color que tendrá la notificación
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [mensajeAlerta, setMensajeAlerta] = useState(""); //mensaje que contendrá el componente "alerta"
  const [finalizar, setFinalizar] = useState(1); //finalizar === 1 lo manda como prop el componente "notify" e indica que la transaccion ha finalizado y debe ejecutarse la funcion para cerrar
  const [severityAlerta, setSeverityAlerta] = useState(""); //define severidad de la alerta (success error o warning)
  const [severitySnack, setSeveritySnack] = useState(""); //define severidad del snackbar (notificación)
  const [disBtn, setDisBtn] = useState(false);

  //diaglo
  const [open, setOpen] = useState(true);
  const [fullWidth, setFullWidth] = useState(true);
  // const [maxWidth, setMaxWidth] = useState('lg');
  const [scroll, setScroll] = useState("paper");

  const handleAlmacenar = (e, source = "select") => {
    const value = parseInt(e.target.value);

    setDatospedido((prev) => ({
      ...prev,
      id_menu: value,
      // Opcionalmente puedes resetear observaciones u otros campos si quieres
    }));
  };
  useEffect(() => {
    // console.log("📦 Cambios en datospedido:", datospedido);
  }, [datospedido]);
  const [checkvianda, setCheckvianda] = useState(
    //1
    datospedido.descuentan_ganancias === 1 ? true : false
  ); //solo maneja lo visual el dato verdadero lo maneja el agregar familiares

  const handleChange2 = (e) => {
    //2
    setCheckvianda(e.target.checked); //segun la documentacion de react
  };

  const ObtenermenusDiarios = () => {
    fetch(UrlApi + "/viandasfech/obtenermenudiario")
      .then((data) => data.json())
      .then((data) => {
        // Ordenamos los menús diarios por fecha (de lunes a domingo)
        //
        const menusOrdenados = data.sort(
          (a, b) => new Date(a.fecha) - new Date(b.fecha)
        );
        setMenusDiarios(menusOrdenados);
      });
  };
  //console.log("menusDiarios", menusDiarios);

  const ObtenermenusRotativos = () => {
    fetch(UrlApi + "/viandasfech/obtenermenurotativo")
      .then((data) => data.json())
      .then((data) => setMenusRotativos(data));
  };
  // console.log("menusRotativos", menusRotativos);

  useEffect(() => {
    ObtenermenusDiarios();
    ObtenermenusRotativos();
  }, []);
  //put

  //Snackbar Notificacion
  const handleClickSnack = () => {
    setOpenSnack(true);
  };
  //si usas la const open del dialog estaria en uso
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    setOpen(false);

    handleClose();
  };
  const handleClose = () => {
    if (props.modificaciones) {
      setOpen(false);
      props.modificaciones(false);
      props.updatetabla(false);
    }
  };
  useEffect(() => {
    if (datospedido) {
      const nuevoEstado = props.activar ? 1 : 0;
      setPedidoParams({ idPedido: datospedido.id_pedidos, nuevoEstado });
    }
  }, [datospedido, props.activar]);

  const editar = async (id_pedido, nuevoEstado) => {
    setDisBtn(true);
    try {
      const response = await fetch(
        `${UrlApi}/viandas/pedidos/estado/${id_pedido}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estado: nuevoEstado }),
        }
      );

      if (!response.ok) throw new Error("Error al actualizar el estado");

      const text = await response.text();
      const data = text ? JSON.parse(text) : null;

      console.log("Estado actualizado:", data);
      props.mostrarAlertaTemporal(
        "✅ Estado actualizado correctamente",
        "success"
      );

      props.updatetabla(true); //para actualizar la tabla
      props.modificaciones(false); //abre el modal editar
      props.setActivar(false); // estado de los funcion activar o desactivar
    } catch (error) {
      console.error("Error en la actualización:", error);
      alert("❌ Hubo un error al actualizar el estado");
    }
  };

  return (
    <>
      <Container>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth={fullWidth}
          maxWidth={"sm"} //sm ls md achicar estiramiento del dialog segun los campso
          // maxHeight={"900px"}
        >
          <form onSubmit={editar}>
            <DialogTitle sx={{ textAlign: "center" }}>
              <Typography
                variant="h6"
                color={props.activar ? "success.main" : "error"}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <WarningIcon sx={{ fontSize: 40, mb: 1 }} color="warning" />
                {props.activar ? "Activar Pedido" : "Desactivar Pedido"}
              </Typography>
            </DialogTitle>

            <DialogContent>
              <DialogContentText align="center" sx={{ mb: 2 }}>
                {props.activar
                  ? "¿Está seguro que desea activar este pedido? El pedido será marcado como activo y estará disponible para su procesamiento."
                  : "¿Está seguro que desea desactivar este pedido? El pedido será marcado como inactivo y no podrá ser procesado."}
              </DialogContentText>
              <Typography variant="body2" align="center" gutterBottom>
                Fecha del pedido:{" "}
                {datospedido?.fecha
                  ? moment(datospedido.fecha).format("DD-MM-YYYY")
                  : "Sin fecha"}
              </Typography>

              <DialogActions>
                <Grid container>
                  <Grid item xs={10} ml={-1.3}>
                    <Button
                      variant="contained"
                      onClick={handleClose}
                      style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                    >
                      Volver
                    </Button>
                  </Grid>

                  <Grid item xs={1} ml={-2}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="success"
                      onClick={() => {
                        if (pedidoParams) {
                          editar(
                            pedidoParams.idPedido,
                            pedidoParams.nuevoEstado
                          );
                        }
                      }}
                      disabled={disBtn}
                    >
                      Confirmar
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </DialogContent>

            <Stack spacing={2} sx={{ width: "100%" }}>
              <Snackbar
                open={openSnack}
                autoHideDuration={1500}
                onClose={handleCloseSnack}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <Alert
                  onClose={handleCloseSnack}
                  severity="success"
                  sx={{ width: "100%" }}
                  style={{ backgroundColor: colormensaje, color: "black" }}
                >
                  {mensaje}
                </Alert>
              </Snackbar>
            </Stack>
          </form>
        </Dialog>
      </Container>

      {notificacion ? (
        <Notify
          mensaje={mensaje}
          open={openSnack}
          color={colormensaje}
          finalizar={setFinalizar}
          severity={severitySnack}
        />
      ) : null}
      {/* ALERT --> SE MUESTRA SI HAY UN ERROR EN LA API (NO SE CONECTA O ESTÁ MAL LA RUTA, ETC.) */}
      {error && mensajeAlerta ? (
        <Alerta mensaje={mensajeAlerta} severity={severityAlerta} />
      ) : null}
    </>
  );
}

export default Editarvianda;
